import React from "react";
import { CSSReset, ChakraProvider } from "@chakra-ui/core";
import hometimeTheme from "./hometimeTheme";
import { jsx as ___EmotionJSX } from "@emotion/react";

var HometimeThemeProvider = function HometimeThemeProvider(props) {
  return ___EmotionJSX(ChakraProvider, {
    theme: hometimeTheme
  }, ___EmotionJSX(CSSReset, null), props.children);
};

export default HometimeThemeProvider;